import { render } from "./Publications_en.vue?vue&type=template&id=ec0ae77a&scoped=true"
import script from "./Publications_en.vue?vue&type=script&lang=js"
export * from "./Publications_en.vue?vue&type=script&lang=js"

import "@/assets/css/globalen.css?vue&type=style&index=0&id=ec0ae77a&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec0ae77a"]])

export default __exports__